import * as analytics from '@actions/analytics';
import { recoverLegacyStorage } from '@actions/localStorageRecovery';
import * as monitoring from '@core/monitoring';
import '@styles/global.css';
import { efTheme, ipacTheme } from '@styles/themes.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

monitoring.init();

const container = document.getElementById('leadFormContainer');
if (!container) {
  throw Error('leadFormContainer id is not definied');
}

const isIpac = window.location.hostname === 'www.ipac-online.com';
container.classList.add(isIpac ? ipacTheme : efTheme);

recoverLegacyStorage();
analytics.init();

const root = createRoot(container);

root.render(
  <StrictMode>
    <App isIpac={isIpac} />
  </StrictMode>,
);
